import * as React from "react";
import styled from "styled-components";
import scrollParent from "../../../utils/scrollParent";
import throttle from "../../../utils/throttle";
import { abortedPromise, ABORT_REASON } from "../../../utils/abortedPromise";
export const HoldContainer = styled.section ``;
export var EDataLoadStatus;
(function (EDataLoadStatus) {
    EDataLoadStatus[EDataLoadStatus["ALREADY_LOAD_ALL_DATA"] = 0] = "ALREADY_LOAD_ALL_DATA";
    EDataLoadStatus[EDataLoadStatus["LOADING_DATA"] = 1] = "LOADING_DATA";
    EDataLoadStatus[EDataLoadStatus["LOAD_DATA_FAIL"] = 2] = "LOAD_DATA_FAIL";
    EDataLoadStatus[EDataLoadStatus["WAIT_FOR_TRIGGER_LOAD"] = 3] = "WAIT_FOR_TRIGGER_LOAD";
})(EDataLoadStatus || (EDataLoadStatus = {}));
export default class ScrollLoad extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLoadStatus: EDataLoadStatus.WAIT_FOR_TRIGGER_LOAD,
            prevDataKey: this.props.dataKey || "",
        };
        this.initStatus = (status) => {
            this.setState({ dataLoadStatus: status });
        };
        this.scrollLoad = () => {
            if (!!this.stuffsContainer) {
                const parentHeight = window.screen.availHeight;
                const innerRect = this.stuffsContainer.getBoundingClientRect();
                const { orientation } = this.props;
                const isNeedLoad = (orientation !== "horizontal" && innerRect.bottom < parentHeight * 4) ||
                    (orientation === "horizontal" &&
                        this.scrollContainerElement.scrollWidth -
                            this.scrollContainerElement.scrollLeft <
                            this.scrollContainerElement.offsetWidth * 2);
                if (isNeedLoad && this.state.dataLoadStatus === EDataLoadStatus.WAIT_FOR_TRIGGER_LOAD) {
                    this.loadData();
                }
            }
        };
        this.processLoadError = (error) => {
            if (error !== ABORT_REASON) {
                if (this.props.needRetryIfError) {
                    this.setState({ dataLoadStatus: EDataLoadStatus.LOAD_DATA_FAIL });
                }
                else {
                    this.setState({ dataLoadStatus: EDataLoadStatus.WAIT_FOR_TRIGGER_LOAD });
                }
            }
            this.cancelPrevLoadPromise = void 0;
        };
        this.onScrollLoad = throttle(this.scrollLoad, 120);
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevDataKey && nextProps.dataKey !== prevState.prevDataKey) {
            return {
                prevDataKey: nextProps.dataKey,
                dataLoadStatus: EDataLoadStatus.WAIT_FOR_TRIGGER_LOAD,
            };
        }
        return prevState;
    }
    componentDidMount() {
        this.scrollContainerElement = scrollParent(this.stuffsContainer);
        this.scrollContainer = document;
        this.scrollContainer.addEventListener("scroll", this.onScrollLoad);
        if (this.props.loadDataWhenDidMount) {
            this.loadData();
        }
    }
    componentDidUpdate(...updateProps) {
        const [, prevState] = updateProps;
        if (prevState.prevDataKey && this.state.prevDataKey !== prevState.prevDataKey) {
            if (!!this.cancelPrevLoadPromise) {
                this.cancelPrevLoadPromise.abort();
                this.cancelPrevLoadPromise = void 0;
            }
            if (this.props.loadDataWhenDidMount) {
                this.loadData();
            }
        }
    }
    componentWillUnmount() {
        if (!!this.scrollContainer) {
            this.scrollContainer.removeEventListener("scroll", this.onScrollLoad);
        }
        if (!!this.cancelPrevLoadPromise) {
            this.cancelPrevLoadPromise.abort();
        }
    }
    loadData() {
        const { loadFunction, isDisable } = this.props;
        if (isDisable) {
            return;
        }
        if (this.state.dataLoadStatus === EDataLoadStatus.LOADING_DATA) {
            return;
        }
        this.setState({ dataLoadStatus: EDataLoadStatus.LOADING_DATA });
        this.cancelPrevLoadPromise = abortedPromise(loadFunction());
        this.cancelPrevLoadPromise.then(({ loadCount, isError }) => {
            if (loadCount !== -999) {
                if (isError) {
                    this.processLoadError();
                }
                else {
                    this.setState({ dataLoadStatus: EDataLoadStatus.WAIT_FOR_TRIGGER_LOAD });
                    this.cancelPrevLoadPromise = void 0;
                }
            }
        }, this.processLoadError);
    }
    render() {
        const { StyleComponent = HoldContainer, grid = {}, style = {} } = this.props;
        return (React.createElement(StyleComponent, Object.assign({ ref: (me) => (this.stuffsContainer = me), className: this.props.className }, grid, { style: style, "data-panel": "scrollpanel" }), this.props.children));
    }
}
ScrollLoad.defaultProps = {
    loadDataWhenDidMount: true,
    needRetryIfError: false,
    isShowLoading: false,
};
